import { render } from "./InviteFriendsModal.vue?vue&type=template&id=5a58165f"
import script from "./InviteFriendsModal.vue?vue&type=script&lang=ts"
export * from "./InviteFriendsModal.vue?vue&type=script&lang=ts"
script.render = render

export default script